export const BASE_URL = 'features/modules/cbp-ui';
